import React, { useEffect, useState } from "react";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { BrowserRouter, Route, Routes } from "react-router-dom";
// import ReactGA from 'react-ga';
import KeycloakAuth from "./helpers/KeycloakAuth"
import PublicRoute from "./helpers/PublicRoute";
import PrivateRoute from "./helpers/PrivateRoute";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Registo from "./pages/Registo";
import RecuperarPassword from "./pages/RecuperarPassword";
import Ajuda from "./pages/Ajuda";
import Dashboard from "./pages/Dashboard";
import ExtratoIndividual from "./pages/ExtratoIndividual";
import ExtratoConsolidado from "./pages/ExtratoConsolidado";
import Pedido from "./pages/Pedido";
import DadosPessoais from "./pages/DadosPessoais";
import VersionChecker from "./components/versionChecker";
import GestaoPedidos from "./components/data/GestaoPedidos";
import { Helmet } from "react-helmet";
import { hideCookieButton } from "../src/helpers/utils"

import Pedidos from "./pages/Pedidos";
// import StatusUtilizador from "./pages/StatusUtilizador";

const TRACKING_ID = "UA-220438183-5";

/* DESABILITAR GOOGLE ANALYTICS */
// ReactGA.initialize(TRACKING_ID);

function App() {

  useEffect(() => {
    if (process.env.REACT_APP_GTM_INJECT == "true") {
      const script = document.createElement('script');
      script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${process.env.REACT_APP_GTM_ID}');
      `;
      document.head.appendChild(script);

      const noscript = document.createElement('noscript');
      noscript.innerHTML = `
      <iframe src=${process.env.REACT_APP_GTM_SRC}
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
      `;
      document.body.appendChild(noscript);
    }

    if (process.env.REACT_APP_ONE_TRUST_INJECT === "true") {
      // Inject OneTrust Autoblock Script
      const autoblockScript = document.createElement("script");
      autoblockScript.type = "text/javascript";
      autoblockScript.src = process.env.REACT_APP_ONE_TRUST_AUTOBLOCK_SRC;
      document.head.appendChild(autoblockScript);

      // Inject OneTrust Main Script
      const oneTrustScript = document.createElement("script");
      oneTrustScript.type = "text/javascript";
      oneTrustScript.src = process.env.REACT_APP_ONE_TRUST_SRC;
      oneTrustScript.charset = "UTF-8";
      oneTrustScript.setAttribute("data-document-language", "true");
      oneTrustScript.setAttribute("data-domain-script", process.env.REACT_APP_ONE_TRUST_ID);
      document.head.appendChild(oneTrustScript);

      // Inject OptanonWrapper function
      const inlineScript = document.createElement("script");
      inlineScript.type = "text/javascript";
      inlineScript.innerHTML = `function OptanonWrapper() { }`;
      document.head.appendChild(inlineScript);
    }

    /* DESABILITAR GOOGLE ANALYTICS */
    // ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <VersionChecker />  {/*  Version Component */}
      <ReactKeycloakProvider initOptions={{ onLoad: 'check-sso', checkLoginIframe: false }} authClient={KeycloakAuth}>
        {/* <React.StrictMode> */}
        <Header />
        <BrowserRouter>
          <div style={{ flex: 1 }}>
            <Routes>
              <Route
                path="/"
                element={
                  <PublicRoute>
                    <Home />
                  </PublicRoute>
                }
              />
              <Route
                path="/registo"
                element={
                  <PublicRoute>
                    <Registo />
                  </PublicRoute>
                }
              />
              <Route
                path="/recuperarpassword"
                element={
                  <PublicRoute>
                    <RecuperarPassword />
                  </PublicRoute>
                }
              />
              <Route
                path="/ajuda"
                element={
                  <Ajuda />
                }
              />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/extratoindividual"
                element={
                  <PrivateRoute>
                    <ExtratoIndividual />
                  </PrivateRoute>
                }
              />
              <Route
                path="/extratoindividual/:id"
                element={
                  <PrivateRoute>
                    <ExtratoIndividual />
                  </PrivateRoute>
                }
              />
              <Route
                path="/extratoconsolidado"
                element={
                  <PrivateRoute>
                    <ExtratoConsolidado />
                  </PrivateRoute>
                }
              />
              <Route
                path="/registarpedido"
                element={
                  <PrivateRoute>
                    <Pedido />
                  </PrivateRoute>
                }
              />
              <Route
                path="/dadospessoais"
                element={
                  <PrivateRoute>
                    <DadosPessoais />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pedidos"
                element={
                  <PrivateRoute>
                    <Pedidos />
                  </PrivateRoute>
                }
              />
            </Routes>
          </div>
        </BrowserRouter>
        <Footer />
        {/* </React.StrictMode> */}
      </ReactKeycloakProvider>
    </div>
  );
}

export default App;
